

























import { SearchBuilder } from "@/builder";
import { debounce } from "@/helpers/debounce";
import { useInvoiceAPPrepayment } from "@/hooks";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { PREPAYMENT_STATUS } from "@/models/enums/prepayment.enum";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class APPaymentsSelectInvoicePrepayment extends Vue {
  @Prop({ default: "" }) value!: string;

  @Prop({ default: "" }) currencyCode!: string;
  @Prop({ default: "" }) branchId!: string;
  @Prop({ default: "" }) supplierId!: string;
  @Prop({ default: false }) disabled!: boolean;

  optInvoices: Option[] = [];
  loading = false;

  created(): void {
    const q = this.buildQuery();
    const params = new RequestQueryParams(q);
    if (this.value) {
      const searchBySecureId = new SearchBuilder()
        .push(["secureId", this.value])
        .build();
      params.search = searchBySecureId;
    }
    this.fetchInvoicesPrepayment(params);
  }

  @Watch("currencyCode")
  onChangeCurrencyCode(): void {
    const params = new RequestQueryParams(this.buildQuery());
    this.fetchInvoicesPrepayment(params);
  }

  @Watch("branchId")
  onChangeBranch(): void {
    const params = new RequestQueryParams(this.buildQuery());
    this.fetchInvoicesPrepayment(params);
  }

  @Watch("supplierId")
  onChangeSupplier(): void {
    const params = new RequestQueryParams(this.buildQuery());
    this.fetchInvoicesPrepayment(params);
  }

  buildQuery(): string {
    const builder = new SearchBuilder();
    return builder
      .push(["status", PREPAYMENT_STATUS.UNPAID])
      .and()
      .push(["invoiceType", "Prepayment"])
      .and()
      .push(["branchWarehouse.secureId", this.branchId])
      .and()
      .push(["supplier.secureId", this.supplierId])
      .and()
      .push(["priceCurrency.currencyCode", this.currencyCode])
      .build();
  }

  onChange(value = ""): void {
    this.$emit("change", value);
  }

  onSearch(value = ""): void {
    const builder = new SearchBuilder();
    const q: string[] = [this.buildQuery()];
    if (value) {
      q.push(builder.push(["documentNumber", value], { like: "both" }).build());
    }
    const params = new RequestQueryParams(q.join(builder.AND));
    debounce(() => {
      this.fetchInvoicesPrepayment(params);
    });
  }

  fetchInvoicesPrepayment(params: RequestQueryParamsModel): void {
    const { findAll, toOptions } = useInvoiceAPPrepayment();
    this.loading = true;
    findAll(params)
      .then(response => {
        this.optInvoices = toOptions(response.data);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
